import { render, staticRenderFns } from "./EditSbpImageModal.vue?vue&type=template&id=5b596ebe&scoped=true&"
import script from "./EditSbpImageModal.vue?vue&type=script&lang=js&"
export * from "./EditSbpImageModal.vue?vue&type=script&lang=js&"
import style0 from "./EditSbpImageModal.vue?vue&type=style&index=0&id=5b596ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b596ebe",
  null
  
)

export default component.exports